<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="content-page-header">
            <h5>Referrals</h5>
            <div class="list-btn">
              <ul class="filter-list"></ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <div class="row">
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :loading="isFetching"
                    :data-source="referrals"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        <span>{{ index + 1 }}</span>
                      </template>
                      <template v-else-if="column.key === 'name'">
                        <router-link
                          style="color: #878a99"
                          :to="`/customer-details/` + record.id"
                        >
                          {{ record.name }}</router-link
                        >
                      </template>
                      <template v-else-if="column.key === 'email'">
                        {{ record.email }}
                      </template>
                      <template v-else-if="column.key === 'phone'">
                        {{ record.phone }}
                      </template>
                      <template v-else-if="column.key === 'amount_due'">
                        <span>{{ useCurrency(record.amount_due) }}</span>
                      </template>
                      <template v-else-if="column.key === 'created_at'">
                        <span>{{ formatted(record.created_at) }}</span>
                      </template>
                      <template v-if="column.key === 'action'">
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <div class="dropdown dropdown-action">
                            <a
                              href="javascript:;"
                              class="btn-action-icon"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              >Action</a
                            >
                            <div class="dropdown-menu dropdown-menu-end">
                              <ul>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/customer-details/` + record.id"
                                    ><i class="far fa-eye me-2"></i
                                    >View</router-link
                                  >
                                </li>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/edit-customer/` + record.id"
                                    ><i class="far fa-edit me-2"></i
                                    >Edit</router-link
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    href="javascript:void(0);"
                                    @click="openModal(record)"
                                    ><i class="far fa-trash-alt me-2"></i
                                    >Delete</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { formatted } from "@/assets/composables/date";
import { useCurrency } from "@/assets/composables/currency";
import { useStore } from "vuex";

const store = useStore();
const isFetching = ref(false);

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Name",
    key: "name",
    sorter: true,
  },
  {
    title: "Email",
    key: "email",
    sorter: true,
  },
  {
    title: "Phone",
    key: "phone",
    sorter: true,
  },
  {
    title: "Amount due",
    key: "amount_due",
    sorter: true,
  },
  {
    title: "Date Added",
    key: "created_at",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const referrals = computed(() => {
  return store.getters["auth/referrals"];
});

const getReferrals = () => {
  isFetching.value = true;
  store
    .dispatch("auth/getReferrals")
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

onMounted(() => {
  getReferrals();
});
</script>
